import { colors, InfoCard } from '@prenuvo/shared-library';

export type ErrorPopupType = {
  onClose: () => void;
  title: string;
  message: string;
};

// ----------------------------------------------------------------------

const ErrorPopup = ({ onClose, message, title }: ErrorPopupType) => {
  return message ? (
    <InfoCard
      icon={{
        name: 'alert',
        color: colors.error,
        size: 80,
        viewSize: 100,
      }}
      headerText={title}
      bodyText={message}
      handleClose={onClose}
    />
  ) : null;
};
export default ErrorPopup;
